import { useEffect, useState } from 'react'

import { useLocale } from '@/hooks/use-locale'
import { useGetNewListByListIds } from '@/services/news'
import { TGetNewsListByListIdParams } from '@/services/news/news.type'
import { Locale } from '@/types/locales'

const ERROR_MESSAGES = {
  '401': "This site can't view this news",
  '404': 'This news not found',
}

const useReplaceDataEditor = (data: string) => {
  const [newData, setNewData] = useState<string>(data)

  const doc = new DOMParser().parseFromString(data, 'text/html')
  const lang = useLocale()
  const listRelatedContent = doc.querySelectorAll('div[data-type="container-related-content"]')
  const listDataId: TGetNewsListByListIdParams[] = Array.from(listRelatedContent).map(
    (relatedContent) => {
      return {
        ids: relatedContent.getAttribute('data-id')?.split('-').map(Number) || [],
        langType: lang as Locale,
      }
    },
  )
  const query = useGetNewListByListIds(listDataId)

  const isLoading = query.some((query) => query.isLoading)
  useEffect(() => {
    const listData = query.map((item) => {
      return item.data?.data
    })
    if (listData.length === 0) {
      setNewData(data)
      return
    }
    listRelatedContent.forEach((relatedContent, index) => {
      const wrapperRelatedContent = document.createElement('div')
      wrapperRelatedContent.classList.add('wrapper-related-content')

      const titleRelatedContent = document.createElement('p')
      titleRelatedContent.classList.add('related-content-title')
      titleRelatedContent.innerHTML = lang === 'en' ? 'Related Content' : '연관 콘텐츠'
      const containerRelatedContent = document.createElement('div')
      containerRelatedContent.classList.add('related-content-container')

      if (listData[index] && !isLoading) {
        listData[index]?.data.forEach((item, index2) => {
          if (item.status === 200) {
            const relatedContent = document.createElement('a')
            relatedContent.classList.add('related-content')
            relatedContent.href = `/${lang}/news/${item.id}`

            const relatedContentImage = document.createElement('img')
            relatedContentImage.src = item.detail?.thumbnail
            relatedContentImage.alt = item.detail?.title
            relatedContentImage.classList.add('related-content-image')

            const relatedContentDescription = document.createElement('p')
            relatedContentDescription.classList.add('related-content-description')
            relatedContentDescription.innerHTML = item.detail?.title

            const divWrapperIcon = document.createElement('div')
            divWrapperIcon.classList.add('related-content-wrapper-icon')

            const relatedContentnaviagtion = document.createElement('div')
            relatedContentnaviagtion.classList.add('related-content-icon-navigate')

            divWrapperIcon.appendChild(relatedContentnaviagtion)

            relatedContent.appendChild(relatedContentImage)
            relatedContent.appendChild(relatedContentDescription)
            relatedContent.appendChild(divWrapperIcon)

            containerRelatedContent.appendChild(relatedContent)
          } else {
            const relatedContent = document.createElement('div')
            relatedContent.classList.add('related-content')
            const relatedContentDescription = document.createElement('p')
            relatedContentDescription.classList.add('related-content-description')
            relatedContentDescription.innerHTML = `${item.status === 401 ? ERROR_MESSAGES[401] : ERROR_MESSAGES[404]}`

            relatedContent.appendChild(relatedContentDescription)

            containerRelatedContent.appendChild(relatedContent)
          }
          if (listData[index]?.data && index2 !== (listData[index]?.data?.length || 1) - 1) {
            const relatedContentDivider = document.createElement('hr')
            relatedContentDivider.classList.add('related-content-divide')
            containerRelatedContent.appendChild(relatedContentDivider)
          }
        })
      }

      wrapperRelatedContent.appendChild(titleRelatedContent)
      wrapperRelatedContent.appendChild(containerRelatedContent)

      relatedContent.replaceWith(wrapperRelatedContent)
    })
    setNewData(doc.body.innerHTML)
  }, [query, lang, listRelatedContent, isLoading])

  return newData
}

export default useReplaceDataEditor
